export enum CurrencyEnum {
    USD = 'USD',
    JPY  = 'JPY'
}

export interface CurrencyItem {
    currency: CurrencyEnum;
    name: string;
    inputId?: string;
}